import { StateCreator } from 'zustand';
import { UIStore } from '../../../../stores/ui/ui-store';
import { EditorAction, EditorSlice, FontToolbarInlineTool, ImageEditToolbarTool } from './editor-ui-slice.types';

const initialEditorState = {
  isTextDrawerOpen: false,
  isImageEditToolbarOpen: false,
  imageEditToolbarActiveTool: null as ImageEditToolbarTool | null,
  isFontToolbarOpen: false,
  fontToolbarActiveTool: null as FontToolbarInlineTool | null,
};

export const createEditorSlice: StateCreator<UIStore, [['zustand/devtools', never]], [], EditorSlice> = (set) => ({
  ...initialEditorState,
  openTextDrawer: () => set({ isTextDrawerOpen: true }, false, EditorAction.OpenTextDrawer),
  closeTextDrawer: () => set({ isTextDrawerOpen: false }, false, EditorAction.CloseTextDrawer),
  openImageEditToolbar: () =>
    set(
      { isImageEditToolbarOpen: true, isFontToolbarOpen: false, fontToolbarActiveTool: null },
      false,
      EditorAction.OpenImageEditToolbar,
    ),
  closeImageEditToolbar: () =>
    set({ isImageEditToolbarOpen: false, imageEditToolbarActiveTool: null }, false, EditorAction.CloseImageEditToolbar),
  setImageEditToolbarActiveTool: (tool: ImageEditToolbarTool | null) =>
    set({ imageEditToolbarActiveTool: tool }, false, EditorAction.SetImageEditToolbarActiveTool),
  openFontToolbar: () =>
    set(
      { isFontToolbarOpen: true, isImageEditToolbarOpen: false, imageEditToolbarActiveTool: null },
      false,
      EditorAction.OpenFontToolbar,
    ),
  // Closing the font toolbar resets the active inline tool so the next open always shows the action row.
  closeFontToolbar: () =>
    set({ isFontToolbarOpen: false, fontToolbarActiveTool: null }, false, EditorAction.CloseFontToolbar),
  setFontToolbarActiveTool: (tool: FontToolbarInlineTool | null) =>
    set({ fontToolbarActiveTool: tool }, false, EditorAction.SetFontToolbarActiveTool),
  // NOTE: `closeAllDrawers` intentionally only resets the legacy text-drawer
  // flag here. The ImageEditToolbar and FontToolbar have isolated lifecycles
  // and are closed via their own actions to prevent unrelated callers
  // (e.g. fabric's `selection:cleared`) from dismissing them mid-interaction.
  closeAllDrawers: () => set({ isTextDrawerOpen: false }, false, EditorAction.CloseAllDrawers),
  closeAllToolbars: () =>
    set(
      {
        isTextDrawerOpen: false,
        isImageEditToolbarOpen: false,
        imageEditToolbarActiveTool: null,
        isFontToolbarOpen: false,
        fontToolbarActiveTool: null,
      },
      false,
      EditorAction.CloseAllToolbars,
    ),
});
